const WaterSupplyContent = [
  {
    title: "Introduction",
    description: `
      Access to safe and reliable water supply is essential for human health, economic development, 
      and environmental sustainability. Many communities in [target area] continue to experience 
      inadequate or intermittent water services due to aging infrastructure, groundwater depletion, 
      and poor management practices.

      The Water Supply Scheme (WSS) seeks to provide sustainable, safe, and equitable water access 
      through the development, rehabilitation, or expansion of water supply systems in line with 
      national water and sanitation policies and the Sustainable Development Goal 6.
    `,
  },
  {
    title: "Objectives",
    description: `
      To ensure continuous and safe water supply for domestic, institutional, and small-scale productive 
      uses in [target area].
    `,
    objectives: [
      "To develop or rehabilitate water supply infrastructure (source, storage, and distribution).",
      "To strengthen local institutions for efficient water service delivery.",
      "To promote community ownership, participation, and cost recovery mechanisms.",
      "To enhance water quality monitoring and promote safe water use practices.",
    ],
  },
  {
    title: "Expected Outcomes",
    outcomes: [
      "Reliable and safe water supply for households / people.",
      "Reduction in waterborne diseases.",
      "Strengthened local management capacity for O&M.",
      "Increased community participation and cost recovery.",
      "Improved hygiene and sanitation practices.",
    ],
  },
];

export default WaterSupplyContent;
